import styled from "styled-components";

export const SectionTitle = styled.div`
    font-size: 18px;
    text-align: center;
    margin-bottom: 1rem;
    color: #4b371b;
    font-weight: 600;
`;
